import React, { useContext } from "react";
import { Button, Card, Space, Typography } from "antd";
import { FilePdfOutlined } from "@ant-design/icons";
import { AuthContext } from "@CONTEXTS";

const { Title } = Typography;

const DOCUMENTS = [
  {
    key: "user-guide",
    title: "JetPartner Kullanıcı Dokümanı",
    file: "/files/JetPartner Kullanıcı Dokümanı.pdf",
    authority: "USER_MANAGEMENT",
  },
  {
    key: "solution-center-guide",
    title: "JetPartner Çözüm Merkezi Kullanım Kılavuzu",
    file: "/files/JetPartner Çözüm Merkezi Kullanım Kılavuzu.pdf",
  },
];

const SupportDocuments = () => {
  const { info } = useContext(AuthContext);

  const visibleDocuments = DOCUMENTS.filter(
    (doc) => !doc.authority || info?.authorities?.includes(doc.authority)
  );

  const openDocument = (file) => {
    window.open(file, "_blank", "noopener,noreferrer");
  };

  return (
    <div className="app-dashboard" style={{ padding: 24 }}>
      <Title level={4} style={{ marginBottom: 24 }}>
        Dokümanlar
      </Title>
      <Space
        direction="vertical"
        size={16}
        style={{ width: "100%", maxWidth: 640 }}
      >
        {visibleDocuments.map((doc) => (
          <Card key={doc.key} style={{ borderRadius: 12 }}>
            <Space style={{ width: "100%", justifyContent: "space-between" }}>
              <Space>
                <FilePdfOutlined style={{ fontSize: 24, color: "#7723db" }} />
                <span>{doc.title}</span>
              </Space>
              <Button type="primary" onClick={() => openDocument(doc.file)}>
                Görüntüle
              </Button>
            </Space>
          </Card>
        ))}
      </Space>
    </div>
  );
};

export default SupportDocuments;
